const ROOT_PATHS = Object.freeze({
  GETTING_STARTED: '/getting-started',
  OVERVIEW: '/overview',
  ORDERS: '/orders',
  REQUESTS: '/requests',
  ANALYTICS: '/analytics',
  CONFIGURE: '/configure',
  SETTINGS: '/settings',
  HELP_AND_SUPPORT: '/help-and-support'
});

export default Object.freeze({
  ACCOUNT_SETTINGS: {
    ROOT: '/account-settings'
  },
  GETTING_STARTED: {
    ROOT: ROOT_PATHS.GETTING_STARTED
  },
  OVERVIEW: {
    ROOT: ROOT_PATHS.OVERVIEW
  },
  ORDERS: {
    ROOT: ROOT_PATHS.ORDERS
  },
  REQUESTS: {
    ROOT: ROOT_PATHS.REQUESTS
  },
  ANALYTICS: {
    ROOT: ROOT_PATHS.ANALYTICS,
    DASHBOARD: `${ROOT_PATHS.ANALYTICS}/dashboard`,
    INSIGHTS: `${ROOT_PATHS.ANALYTICS}/insights`,
    USER_REPORTS: `${ROOT_PATHS.ANALYTICS}/user-reports`
  },
  CONFIGURE: {
    ROOT: ROOT_PATHS.CONFIGURE,
    RETURN_MANAGEMENT: `${ROOT_PATHS.CONFIGURE}/return-management`,
    SHIPPING: `${ROOT_PATHS.CONFIGURE}/shipping`,
    CUSTOMER_PORTAL: `${ROOT_PATHS.CONFIGURE}/customer-portal`
  },
  SETTINGS: {
    ROOT: ROOT_PATHS.SETTINGS,
    MANAGE_SUBSCRIPTION: `${ROOT_PATHS.SETTINGS}/manage-subscription`,
    USER_MANAGEMENT: `${ROOT_PATHS.SETTINGS}/manage-users`,
    MANAGE_APIS: `${ROOT_PATHS.SETTINGS}/manage-apis`,
    ACCOUNT: `${ROOT_PATHS.SETTINGS}/account`
  },
  HELP_AND_SUPPORT: {
    ROOT: ROOT_PATHS.HELP_AND_SUPPORT,
    KNOWLEDGE_BANK: `${ROOT_PATHS.HELP_AND_SUPPORT}/knowledge-bank`,
    WATCH_TUTORIAL: `${ROOT_PATHS.HELP_AND_SUPPORT}/watch-tutorial`
  }
});
